import React from "react";
import Footer from './Footer'
import NaviBarv2 from './NaviBarv2'
import 'bootstrap/dist/css/bootstrap.min.css';
import "../styles.css";
import {Container, Row, Col, Card, ListGroup, ListGroupItem, Button, Tab, Nav,
OverlayTrigger, Popover, Placeholder} from 'react-bootstrap';
import Petrakova from "../images/team/Petrakova.jpg"

export function Petrakova_info () {
  return (
        <>
    <NaviBarv2 />
    <Container>
      <section>
        <div><img src={Petrakova} align="left" width={320} ></img></div>
        <div class="row my-4 ps-4"><h1>Петракова Виктория Сергеевна</h1></div>
        <div class="row ps-4"><p>Кандидат физико-математических наук</p></div>
        <div class="row ps-4"><p>Научный сотрудник</p><hr></hr></div>
        <div class="row ps-4"><h5>📩 vika-svetlakova@yandex.ru</h5>
        <h5>📩 rikka@icm.krasn.ru</h5><hr></hr>
        </div>
        <div class="row">
        <div class="col-sm-5 col-md-6 ps-5">WOS Research ID:<a href="https://www.webofscience.com/wos/author/record/641682">C-4300-2016</a></div>
        <div class="col-sm-5 offset-sm-2 col-md-6 offset-md-0 ">ID РИНЦ:<a rel="noopener" target="_blank" href="https://elibrary.ru/author_profile.asp?authorid=1182060">1182060</a></div>
        </div>
        <div class="row">
        <div class="col-sm-6 col-md-5 col-lg-6 mx-auto ps-5 ">Scopus Author ID:<a href="https://www.scopus.com/authid/detail.uri?authorId=57192186292">57192186292</a><hr></hr></div>
        <div class="col-sm-6 col-md-5 offset-md-2 col-lg-6 offset-lg-0">ORCID: <a href="https://orcid.org/0000-0003-1126-2148">0000-0003-1126-2148</a><hr></hr></div>
        </div>
        <div class="row ps-4"><p><a href="https://ai-biolab.ru/data/Резюме-Петракова_2024.pdf">Резюме</a></p></div>
        <div class="row ps-4"><p>1994</p></div>
        </section>
        <hr></hr>
        <div class="row">
        <div class="col-sm-5 col-md-6"><div class="my-3"><h3>Образование</h3></div>
        <p>2010-2016 г. – Студент Сибирского федерального университета, Научный руководитель: к.ф.-м.н., доцент Е.Д. Карепова (бакалавриат); член-корр. РАН, профессор В.В. Шайдуров.</p>
        <p>2016–2022 г. – Аспирант Сибирского федерального университета, Научный руководитель: член-корр. РАН, профессор В.В. Шайдуров.</p>
        </div>

        <div class="col-sm-5 offset-sm-2 col-md-6 offset-md-0"><div class="my-3"><h3>Профессиональный опыт</h3></div>
        <p> 2016 – н.вр. Доцент базовой кафедры вычислительных и информационных технологий, Сибирский федеральный университет, Красноярск, Россия.</p>
        <p> 2014 – н.вр. научный сотрудник, Институт вычислительного моделирования СО РАН.</p>
        </div>
        </div>
        <hr></hr>
        <div class="row">
        <div class="col-sm-6 col-md-5 col-lg-6 mx-auto"><div class="my-3"><h3>Преподавание</h3></div>
        <p>Параллельное программирование, 4 курс бакалавриата, семинары, СФУ.</p>
        <p>Высокопроизводительные вычисления, 1 курс магистратуры, семинары, СФУ.</p>
        <p>факультатив «Введение в интеллектуальный анализ данных», СФУ.</p>
        <p>научный руководитель 5-ти студентов (4 бакалавра, 1 магистрант)</p></div>
        <div class="col-sm-6 col-md-5 offset-md-2 col-lg-6 offset-lg-0"><div class="my-3"><h3>Профессиональные интересы</h3></div>
        <p>Математическое моделирование.</p>
        <p>Математическая эпидемиология.</p>
        <p>Анализ данных.</p>
        <p>Вычислительная математика.</p>
        <p>Математическая статистика.</p>
        <p>Высокопроизводительные вычисления.</p>
        </div>
        <hr></hr>
        <div class="row">
          <div class="my-3"><h3>Исследовательские проекты и гранты</h3></div>
          <p>РФФИ № 18-47-242005 «Создание эффективных распределенных сетей температурных датчиков для бортовой аппаратуры спутников» (2018-2020) — исполнитель.</p>
          <p>РНФ № 18-72-10005 «Формирование устойчивых комплексных наноструктур за счет самосборки из ансамбля резонансных наночастиц в поле лазерного излучения» (2018-2021) — исполнитель.</p>
          <p>РНФ № 20-61-46017 «Развитие динамических математических моделей прогноза критических социально-экономических ситуаций и создание эффективных численных методов решения таких моделей» (2020-2021) — исполнитель.</p>
          <p>РФФИ № 20-01-00090 «Эйлерово-лагранжевы (полулагранжевы) методы конечных разностей и конечных элементов со специальными свойствами» (2020-2022) — исполнитель.</p>
          <p>РНФ № 18-71-10044 «Суперкомпьютерный анализ социальных, эпидемиологических и экономических процессов. Теория, алгоритмы и комплекс программ» (2021-2023) — исполнитель.</p>
          <p>ККФН № 2022110809055 «Оценка эффективности использования сети недорогих сенсорных датчиков для сбора данных о загрязнениях в пограничных слоях атмосферы на основе анализа наблюдений за динамикой концентрации взвешенных частиц PM2.5» (2022-2023) — руководитель.</p>
          <p>РНФ № 23-71-10068  «Разработка интеллектуальной программной системы мониторинга и моделирования взаимосвязанных эпидемиологических и экономических процессов в Российской Федерации» (2023-2026) — исполнитель.</p>
        </div>
        <hr></hr>
        <div class="row">
        <div class="my-3"><h3>Награды и достижения</h3></div>
        <p>Первая премия Лаврентьевского конкурса студенческих и аспирантских работ по математике и механике «Численные методы решения задач «среднего поля»» (2020).</p>
        <p>Диплом финалиста конкурса на лучшую работу студентов федеральных университетов России 2014 года по естественнонаучному направлению (2014).</p>
        </div>
        </div>
        </Container>
        

    <Footer />
    </>
    
    )}
    
    